import { render, staticRenderFns } from "./subscriptionSidebar.vue?vue&type=template&id=13de12f1&scoped=true&"
import script from "./subscriptionSidebar.vue?vue&type=script&lang=js&"
export * from "./subscriptionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./subscriptionSidebar.vue?vue&type=style&index=0&id=13de12f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de12f1",
  null
  
)

export default component.exports